// extracted by mini-css-extract-plugin
export default {"permissionsSelectors":"PermissionsSelector__permissionsSelectors--E631WYEXRw1Fz4hPRQiT","isDisabled":"PermissionsSelector__isDisabled--PLyWrU8OnMMBB8xtg613"};